import { memo } from 'react';
import { AlertBanner } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { personDisplayName } from '../../../utils/personDisplayName.js';

const NAMES_SHOWN = 6;

/**
 * Warning of the Invitations section: people about to be invited who have no access yet can
 * sign in but open no studio. Lists the first names and how many more there are.
 *
 * @param {object} props
 * @param {Array<{ person: object }>} props.people New rows that will be invited with no access.
 */
function InviteNoAccessNotice({ people }) {
  const { t } = useTranslation('people-access');
  if (people.length === 0) return null;

  const names = people.slice(0, NAMES_SHOWN).map((row) => personDisplayName(row.person));
  const rest = people.length - names.length;
  const listed = rest > 0 ? `${names.join(', ')} ${t('import.check.invitations.noAccess.more', { count: rest })}` : names.join(', ');

  return (
    <AlertBanner tone="warning" title={t('import.check.invitations.noAccess.title', { count: people.length })}>
      {t('import.check.invitations.noAccess.message', { names: listed })}
    </AlertBanner>
  );
}

export default memo(InviteNoAccessNotice);
